<template>
  <div :class="$style.container">
    <vs-tooltip v-if="type && type.iconNew" :text="type.title" :active="true">
      <app-icon :name="type.iconNew" />
      <!-- Фикс появления https://github.com/lusaxweb/vuesax/issues/490 -->
      <!--        <span>&nbsp;</span>-->
    </vs-tooltip>
    <div :class="$style.number">{{ apartment }}</div>
  </div>
</template>

<script>
import * as apartmentTypes from "@/client/dictionaries/apartmentTypes";
import Vue                 from 'vue';

export default Vue.extend({
  name:     "NotifiesApartmentRenderer",
  computed: {
    type() {
      const { data } = this.params;
      if (!data) return null;
      return apartmentTypes.getById(data.apart_type);
    },

    apartment() {
      const { data } = this.params;
      if (!data) return null;
      return data.apart_number;
    },

  },
});
</script>

<style lang="scss" module>
.container {
  display: flex;
  align-items: center;
  height: 100%;
}

.number {
  margin-left: .5em;
}
</style>
